module.exports = __webpack_public_path__ + "images/cm-exams.jpg";